import { useHistory } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { RouteSegmentDataForm, RouteSegmentFilters } from '../../app/models/RouteSegment';
import moment from 'moment';
import useSweetAlert from '../../hooks/useSweetAlert';
import DefaultCard from '../../components/default/DefaultCard';
import ButtonCreate from '../../components/buttons/ButtonCreate';
import { ServiceResponse } from '../../app/services/shared/interfaces';
import useRouteSegmentService from '../../app/services/hooks/useRouteSegmentService';
import RouteSegmentFilter from './components/tables/RouteSegmentFilter';
import DefaultModal from '../../components/default/DefaultModal';
import { toast } from 'react-toastify';
import RouteSegmentCreate from './components/RouteSegmentCreate';
import RouteSegmentEdit from './components/RouteSegmentEdit';
import { AppContext } from '../../contexts/AppContext';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import RouteSegmentDataTable from './components/tables/RouteSegmentDataTable';
import useNavigationPage from '../../hooks/useNavigationPage';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Tramos',
        url: '/route-segments',
        isActive: true
    }
];

const RouteSegment = () => {
    const { navigationPage } = useNavigationPage();

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const history = useHistory();
    const { fetchingGetRouteSegments, getRouteSegments, deleteRouteSegment } =
        useRouteSegmentService();

    const { auth } = useContext(AuthContext);

    const [routeSegmentIdEdit, setRouteSegmentIdEdit] = useState<number>(-1);
    const [showingEdit, setShowingEdit] = useState(false);
    const [routeSegments, setRouteSegments] = useState<RouteSegmentDataForm[]>([]);
    const [totalRows, setTotalRows] = useState(0);

    const [showingCreate, setShowingCreate] = useState(false);

    const [filter, setFilter] = useState<RouteSegmentFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc',
        origin: '',
        destiny: '',
        route_segment_id: null
    });

    useEffect(() => {
        reloadTable();
    }, [filter]);

    const reloadTable = () => {
        getRouteSegments(filter, {
            onSuccess: (response: ServiceResponse) => {
                setRouteSegments(response.data.route_segments);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });

                if (response.data.to_dashboard) {
                    navigationPage('/')
                }
            }
        });
    };

    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };

    const showEdit = (RouteSegmentId: number) => {
        setShowingEdit(true);
        setRouteSegmentIdEdit(RouteSegmentId);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setRouteSegmentIdEdit(-1);
    };

    const onError = () => {
        setShowingEdit(false);
        setRouteSegmentIdEdit(-1);
    };

    const destroy = (routeSegmentId: number) => {
        const _text = 'Está a punto de eliminar el tramo #' + routeSegmentId;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando tramo...');
                        deleteRouteSegment(routeSegmentId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();
                                // useSweetAlert().successAlert({
                                //     title: 'Éxito',
                                //     text: response.message

                                // });
                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });
                                // if(changeAnimation)changeAnimation('success', response.message, true);
                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El tramo no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });

        // useSweetAlert().requestConfirmation({
        //     title: '¿Está seguro?',
        //     text: _text,
        //     confirmButtonText: 'Si, eliminar',
        //     cancelButtonText: 'Cancelar',
        //     onConfirm: () => {
        //         // useSweetAlert().spinnerAlert("Eliminando tramo...");
        //         if(showLoading)showLoading('loading', 'Eliminando tramo...');
        //         deleteRouteSegment(routeSegmentId, {
        //             onSuccess: (response: ServiceResponse) => {
        //                 // useSweetAlert().successAlert({
        //                 //     title: 'Éxito',
        //                 //     text: response.message

        //                 // });
        //                 if(changeAnimation)changeAnimation('defaultSuccess', response.message, true);
        //                 reloadTable();
        //             },
        //             onError: (response: ServiceResponse) => {
        //                 if(hideLoading)hideLoading();

        //                 useSweetAlert().errorAlert({
        //                     title: 'Error',
        //                     text:response.message

        //                 });
        //             }
        //         });
        //     },
        //     onCancel: () => {
        //         useSweetAlert().infoAlert({
        //             title: 'Cancelado',
        //             text: 'El tramo no se ha eliminado.'
        //         });
        //     }
        // });
    };

    return (
        <>
            <Breadcrumbs pageSection="Tramos" breadcrumbs={breadcrumbs} />
            <DefaultCard>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col">
                                <ButtonCreate callbackCreate={showCreate} title="Nuevo tramo" />
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        {/* <RouteSegmentTable
                            routeSegments={routeSegments}
                            callbackSuccess={reloadTable}
                            loading={fetchingGetRouteSegments}
                            destroy={destroy}
                            edit={showEdit}
                            
                        /> */}

                        <RouteSegmentDataTable
                            routeSegments={routeSegments}
                            totalRows={totalRows}
                            loading={fetchingGetRouteSegments}
                            destroy={destroy}
                            edit={showEdit}
                            filter={filter}
                            setFilter={setFilter}
                        />
                    </div>
                </div>
            </DefaultCard>
            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear tramo"
                    backdrop={true}
                    showFooter={false}
                >
                    <RouteSegmentCreate
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}

                    />
                </DefaultModal>
            ) : null}

            {showingEdit ? (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title="Editar Tramo"
                    backdrop={true}
                    showFooter={false}
                >
                    <RouteSegmentEdit
                        routeSegmentId={routeSegmentIdEdit}
                        onSaved={() => {
                            reloadTable();
                            hideEdit();
                        }}
                        onCancel={hideEdit}
                        onError={onError}
                    />
                </DefaultModal>
            ) : null}
        </>
    );
};

export default RouteSegment;
